import Vue from "vue"
import VueTransmit from "vue-transmit"

Vue.use(VueTransmit)
